require('./bootstrap');

require('./admin-lte-config.js');

// require('./laravel-echo.js');
